import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import ConnectorMixin, { ConnectorMixinDefaultValues } from 'automation-ui-action-features/records/connection/ConnectorMixin';
import * as BranchConnectorKeys from 'automation-ui-action-features/constants/BranchConnectorKeys';
import * as ConnectorEdgeTypes from 'automation-ui-action-features/constants/ConnectorEdgeTypes';
import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';

/**
 * BranchConnectors are used in branching actions (such as LIST_BRANCH) to
 * define the connecting action for a branch.
 */
export default class BranchConnector extends ConnectorMixin(createImmutableObjectClass(ConnectorMixinDefaultValues)) {
  // Loop actions' sole branch must always have either an action
  // or a GO_TO back to the starting node
  sanitizeConnector({
    rootLoopNodeId
  }) {
    if (!rootLoopNodeId) {
      return this;
    }
    return new BranchConnector({
      [BranchConnectorKeys.NEXT_ACTION_ID]: rootLoopNodeId,
      [BranchConnectorKeys.EDGE_TYPE]: ConnectorEdgeTypes.GOTO,
      [BranchConnectorKeys.CONNECTION_TYPE]: ConnectionTypes.SINGLE_CONNECTION
    });
  }
}